import { Navigate } from "react-router-dom";
import { getTokens } from "@/utils/token";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const { access: accessToken } = getTokens();

  if (!accessToken) {
    return <Navigate to='/login' replace />;
  }

  return children;
};

export default ProtectedRoute;
